import { Box, useMobile } from '@octano/global-ui';
import { useTranslation } from 'react-i18next';
import { useCallback } from 'react';
import { useTeacherInfoLoader } from '../Loaders/TeacherInfoLoader';
import { format as formatRut } from 'rut.js';
import { TranslationsKeys } from '../../../../../../locales/translations';
import { TeacherInfoResponse } from '../type';

export default function TeacherDetailBox() {
  const prefix = 'teacherDetailsBox';
  const { t } = useTranslation(TranslationsKeys.TEACHER_MANAGMENT_TEACHER_FILE);
  const isMobile = useMobile();

  const { data: teacherInfo } = useTeacherInfoLoader();

  const mapTeacherRole = useCallback(
    (teacherInfo: TeacherInfoResponse) => {
      if (teacherInfo.isHired && teacherInfo.isTutor) {
        return t(`${prefix}.teacherTutor`);
      } else if (teacherInfo.isHired) {
        return t(`${prefix}.teacher`);
      } else if (teacherInfo.isTutor) {
        return t(`${prefix}.tutor`);
      } else {
        return '';
      }
    },
    [t],
  );

  return (
    <Box
      color="primary"
      variant="outlined"
      style={{ borderRadius: 4 }}
      className={`py-2 px-3 ${isMobile && 'mt-4 w-100'}`}
      body={
        <div className="d-flex justify-content-between">
          <Box
            color="primary"
            variant="outlined"
            className="p-0 border-0 w-70 text-uppercase"
            title={t(`${prefix}.user`)}
            style={{ minWidth: isMobile ? 0 : 140, marginRight: 15 }}
            body={
              <p className="fs-14 mb-0 pr-2 text-capitalize">
                {teacherInfo?.account?.fullName}
              </p>
            }
          />
          <Box
            color="primary"
            variant="outlined"
            className="p-0 border-0 w-30 text-uppercase"
            title={t(`${prefix}.id`)}
            style={{ minWidth: isMobile ? 0 : 100 }}
            body={
              <p className="fs-14 mb-0 text-capitalize">
                {teacherInfo?.account?.defaultIdentification?.value &&
                teacherInfo?.account?.defaultIdentification
                  ?.identificationTypeId !== 'PASSPORT'
                  ? formatRut(
                      teacherInfo?.account?.defaultIdentification?.value,
                    )
                  : teacherInfo?.account?.defaultIdentification?.value}
              </p>
            }
          />
          <Box
            color="primary"
            variant="outlined"
            className="p-0 border-0 w-30"
            title={t(`${prefix}.role`)}
            style={{ minWidth: isMobile ? 0 : 100 }}
            body={
              <p className="fs-14 mb-0 text-capitalize">
                {teacherInfo &&
                  (teacherInfo.isHired || teacherInfo.isTutor) &&
                  mapTeacherRole(teacherInfo)}
              </p>
            }
          />
        </div>
      }
    />
  );
}
